import _ from '../../common/utility';
import carousel from '../../common/carousel'
function load(cb){
    loadCoeV2Ads();
    coeV2Share();
    actions();
    addEventListenerForPRMLinks();
    let title = conceptName.toLowerCase();
    let sourceMarker = 'dpcs';
    let url = '';
    const lang = window.locale;
    if (lang === 'es' || lang === 'pt') url = `https://img.${getDomain()}medscapestatic.com/medscape-files/coe/${lang}/${title}.json`;
    else url = `https://img.${getDomain()}medscapestatic.com/medscape-files/coe/${title}.json`;

    $.ajaxSetup({
        timeout: 0
    });

    $.get(url)
        .done(function (resp) {
            let featured, icymi;

            if (resp.metadata) {
                title = resp.metadata.tracking || title;
                sourceMarker = resp.metadata.sourceMarker || sourceMarker;
            }

            featured = `<div class="carousel-content"><ul class="carousel-container  flickity-enabled is-draggable" id="coe_carousel" tabindex="0"> `;
            for (let i = 0; i < resp.Featured.length; i++) {
                let content = resp.Featured[i];
                let video = content.video ? '<span class="imgVideo"></span>' : '';
                let logo = content.logo ? `<img class="colab-logo" src="${content.logo}">` : '';
                let pubTile = content.pub.length>0 ?`<div class="tag callouttag carousel-floating-item "><span class="tag-text">${content.pub}</span>${logo}</div>` :``;
                featured += `
                    <li class="carousel-item" >
                        <a href="${content.link}?src=${sourceMarker}" onclick="wmdTrack('coe-fc_${i + 1}')">
                            <div class="carousel-img" style="background-image:url('${content.thumb}')"></div>
                            ${video}
                            <div class="title carousel-floating-item">${content.title}</div>
                            ${pubTile}
                         </a>
                    </li>`;
            }
            featured += `</ul></div>`;
            $('header .coe_carousel h1').after(featured);
            let inCaseYouMissed;
            if (window.locale == 'es') {
                inCaseYouMissed = "Más contenido"
            }
            else if (window.locale == 'pt') {
                inCaseYouMissed = "Mais conteúdos"
            }
            else {
                inCaseYouMissed = "In Case You Missed It"
            }
            icymi = `<div class="header">${inCaseYouMissed}</div><ul>`;
            for (let i = 0; i < resp.ICYMI.length; i++) {
                let content = resp.ICYMI[i];
                let video = content.video ? '<span class="imgVideo"></span>' : '';
                let logo = content.logo ? `<img class="colab-logo-inline" src="${content.logo}">` : '';
                icymi += `
                <li>
                    <a href="${content.link}?src=${sourceMarker}" onclick="wmdTrack('coe-icymi_${i + 1}')">
                        <img src="//img.medscapestatic.com/pi/global/1x1.png" data-src="${content.thumb}" data-alt="${content.alt}">
                        ${video}
                    </a>
                    <div class="icymi-des">
                        <div class="tag callouttag"><span class="tag-text">${content.pub}</span>${logo}</div>
                        <a href="${content.link}?src=${sourceMarker}" onclick="wmdTrack('coe-icymi_${i + 1}')">
                            <div class="title">${content.title}</div>
                        </a>
                    </div>
                </li>`;
            }
            icymi += '</ul>';
            $('.coe_icymi').append(icymi);
            cb();
            carousel();
            enableCoeInlineAds();
        });
    
}
function loadCoeV2Ads() {
    if (window.breakpoint == 1) {
        $(".hp_bucket3col[data-track=coe-latest] .section-container ul li").eq(1).after(`<li class="ad-item"><div id="ads-pos-1525-sfp" class="AdUnit AdUnit-sfp"></div></li>`);
        $(".hp_news[data-track=coe-news] .section-container ul li").eq(0).after(`<li class="ad-item"><div id="ads-pos-1425-sfp" class="AdUnit AdUnit-sfp"></div></li>`);
        if ($('#ads-pos-1525-sfp').length > 0) {
            delete window.ads2_ignore["1525"];
            webmd.ads2.defineAd({ id: 'ads-pos-1525-sfp', pos: 1525, sizes: [2, 4] });
        }
        if ($('#ads-pos-1425-sfp').length > 0) {
            delete window.ads2_ignore["1425"];
            webmd.ads2.defineAd({ id: 'ads-pos-1425-sfp', pos: 1425, sizes: [2, 4] });
        }

    } else {
        $(".hp_bucket3col[data-track=coe-latest] .section-container ul li").eq(1).after(`<li class="ad-item"><div id="ads-pos-525-sfp" class="AdUnit AdUnit-sfp"></div></li>`)
        $(".hp_news[data-track=coe-news] .section-container ul li").eq(0).after(`<li class="ad-item"><div id="ads-pos-425-sfp" class="AdUnit AdUnit-sfp"></div></li>`)
        if ($('#ads-pos-525-sfp').length > 0) {
            delete window.ads2_ignore["525"];
            webmd.ads2.defineAd({ id: 'ads-pos-525-sfp', pos: 525, sizes: [2, 4] });
        }
        if ($('#ads-pos-425-sfp').length > 0) {
            delete window.ads2_ignore["425"];
            webmd.ads2.defineAd({ id: 'ads-pos-425-sfp', pos: 425, sizes: [2, 4] });
        }        
    }
}
function coeV2Share() {
    let innerSec = $(
      `<section class="coe-v2-share"><div class="coe-v2-share-container"></div></section>`
    );
    let innerSec2 = $(
        `<section class="coe-v2-share coe_icymi-after"><div class="coe-v2-share-container"></div></section>`
      );
    if ($(".coe-v2-no-partner-layout-coe").length > 0) {
      $(".coe-v2-no-partner-layout-coe .disclaimer").after(innerSec);
    } 
    else {
      $('.hp_bucket2col[data-track="coe-quiz"]').before(innerSec);
    }
    $('.coe_icymi').after(innerSec2);
    let shareDom = $(".header-action.icon").clone();
    let _coeShare = $(".coe-v2-share div");
    let coeNameSource = $("header .coe_carousel h1").text();
    _coeShare.html(shareDom);
    _coeShare.prepend(`<h4>Medscape Email Alerts</h4>
    <span class='coe-v2-share-sub-header'>Receive email with curated articles from the ${coeNameSource} Center of Excellence

    </span>`);
    let addemailbtn = $(".add-email-alerts");
    $(".alert-tooltip").hide();
    addemailbtn.on('mouseenter',function(){
        $(".alert-tooltip").show();
    });
    addemailbtn.on('mouseleave',function(){
        $(".alert-tooltip").hide();
    });
}

function actions () {
    $('.facebook').click(() => {
        fburl();
    });

    $('.twitter').click(() => {
        twiturl();
    });

    $('.linkedin').click(() => {
        linkedinurl();
    });

    $('.googleplus').click(() => {
        googleurl();
    });

    $('.whatsapp').click(() => {
        whatsappurl();
    });

    $('.email').click(() => {
        wmdPageLink('ar-share_email');
    })

    $('.close-layer#socialOpen').click(() => {
        $('#social').show();
    });

    $('.close-layer#socialClose').click(() => {
        $('#social').hide();
    });
} 

function enableCoeInlineAds() {
    $(document).one('dfpRenderComp', function () {
        var adsList = (breakpoint === 1) ? [1425, 1525] : [425, 525];
        setTimeout(function () {
            for (let i = 0; i < adsList.length; i++) {
                let coeFallback = $('#ads-pos-' + adsList[i] + '-sfp');
                if ($(coeFallback).length > 0) {
                    if (!$(coeFallback).closest('section').hasClass('has-ad') && !$(coeFallback).hasClass('blank-ad') && $(coeFallback).css('display') !== 'none') {
                        $(coeFallback).closest('section').addClass("has-ad");
                    }
                }
            }
        }, 1000);
    });
}

function addEventListenerForPRMLinks() {
    let PRMcontainer = `${window.breakpoint === 1 ? 'main .hp_poctools~' : '.sticky-ad'} .prm-grey-box .prm-grey-box-related-links .prm-related-links-content`;
    if ($(PRMcontainer).length > 0) {
        let prmContainers = [...document.querySelectorAll(PRMcontainer)];
        prmContainers.forEach((ele, i) => {
            let links = $(ele).find('a');
            let linksArray = $.makeArray(links);
            $(linksArray).on('click', function (e) {
                const targetLinkInd = linksArray.indexOf(this);
                if (targetLinkInd !== -1) {
                    const isPartnerLink = $(this).closest('.prm-related-links-content.partner-links').length > 0;
                    wmdPageLink(`coe-prm${isPartnerLink ? '-partner' : ''}_${targetLinkInd + 1}`, this);
                }
            })
        })
    }
}

export default _.catch(load);